import { jsxs as o, jsx as t } from "react/jsx-runtime";
import m from "react";
import C from "lodash.uniqueid";
import { I as f } from "../../chunks/icon-96vzN0aU.js";
const j = "_textInput_qymof_1", B = "_labelWrapper_qymof_14", F = "_label_qymof_14", L = "_asterisk_qymof_31", R = "_textInputWrapper_qymof_47", S = "_input_qymof_51", T = "_error_qymof_98", V = "_valid_qymof_104", z = "_icon_qymof_111", A = "_checkmark_qymof_118", e = {
  textInput: j,
  labelWrapper: B,
  label: F,
  asterisk: L,
  textInputWrapper: R,
  input: S,
  error: T,
  valid: V,
  icon: z,
  checkmark: A
}, J = ({
  hasError: n = !1,
  inputClassName: d,
  isRequired: h = !1,
  isValid: l,
  labelName: i,
  name: s,
  onBlur: p,
  onChange: u,
  placeholder: k = "",
  shouldAutocomplete: I = !0,
  shouldUseUniqueId: x,
  type: r,
  value: c,
  wrapperClassName: q,
  ...b
}) => {
  const [v, _] = m.useState(c);
  m.useEffect(() => {
    _(c);
  }, [c]);
  const N = (a) => {
    _(a.target.value), u && u(a);
  }, W = (a) => {
    p && p(a);
  }, y = () => r && i ? /* @__PURE__ */ o("div", { className: e.labelWrapper, children: [
    /* @__PURE__ */ t("label", { className: e.label, htmlFor: r, children: i }),
    h && /* @__PURE__ */ t("span", { className: e.asterisk, children: "*" })
  ] }) : null, $ = () => l || n ? /* @__PURE__ */ t("div", { className: e.icon, children: n ? /* @__PURE__ */ t(f, { height: 20, icon: "ErrorCircle", width: 20 }) : /* @__PURE__ */ t("div", { className: e.checkmark, children: /* @__PURE__ */ t(f, { fill: "#fff", height: 20, icon: "Checkmark", width: 20 }) }) }) : null, g = r === "password" ? "current-password" : r, w = `${e.input} ${n ? e.error : ""} ${l ? e.valid : ""} ${d}`;
  return /* @__PURE__ */ o("div", { className: e.textInput, children: [
    y(),
    /* @__PURE__ */ o("div", { className: `${e.textInputWrapper} ${q}`, children: [
      /* @__PURE__ */ t(
        "input",
        {
          autoComplete: I ? g : "off",
          className: w,
          id: x ? C(`${s}_`) : s,
          name: s,
          onBlur: W,
          onChange: N,
          placeholder: k,
          type: r,
          value: v || "",
          ...b
        }
      ),
      $()
    ] })
  ] });
};
export {
  J as default
};
